import ExportLog from '@pages/ExportLog.vue';
import UserProfile from '@pages/UserProfile.vue';
import UserSettings from '@pages/UserSettings.vue';
import UserCompanyProfile from '@pages/UserCompanyProfile.vue';

export default [
  {
    path: '/profile',
    name: 'UserProfile',
    component: UserProfile,
    meta: {
      permissions: [
        {
          role: 'Guest',
          access: false,
          redirect: 'Home',
        },
      ],
    },
  },
  {
    path: '/profile/settings',
    name: 'UserSettings',
    component: UserSettings,
    meta: {
      permissions: [
        {
          role: 'Guest',
          access: false,
          redirect: 'Home',
        },
      ],
    },
  },
  {
    path: '/profile/company',
    name: 'UserCompanyProfile',
    component: UserCompanyProfile,
    meta: {
      permissions: [
        {
          role: 'Guest',
          access: false,
          redirect: 'Login',
        },
        {
          role: 'Member',
          access: false,
          redirect: 'ProfileUser',
        },
        {
          role: 'Superuser',
          access: false,
          redirect: 'ProfileUser',
        },
      ],
    },
  },
  {
    path: '/profile/export-log',
    name: 'ExportLog',
    component: ExportLog,
    meta: {
      permissions: [
        {
          role: 'Guest',
          access: false,
          redirect: 'Home',
        },
      ],
    },
  },
  {
    // Legacy route name kept so existing redirects to `PreviousReports`
    // (post-export, post-login, etc.) continue to land on the Export Log page.
    path: '/profile/previous-reports',
    name: 'PreviousReports',
    component: ExportLog,
    meta: {
      permissions: [
        {
          role: 'Guest',
          access: false,
          redirect: 'Home',
        },
      ],
    },
  },
];
